import { Validator } from 'vee-validate'

export default {
  name: 'Email',
  inject: {
    $validator: '$validator'
  },
  props: {
    value: {
      type: String,
      required: false
    },
    isUnique: {
      type: Boolean,
      required: true
    },
    isReadOnly: {
      type: Boolean
    },
    placeholder: {
      type: String,
      required: true
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emailValue: this.value
    }
  },
  watch: {
    value (val) {
      this.emailValue = val
    }
  },
  created () {
    const isUnique = (value) => {
      return this.$http.get(`checkEmail/${value}`).then((response) => {
        return {
          valid: response.body.unique,
          data: {
            message: 'Your email is not unique'
          }
        }
      })
    }

    Validator.extend('unique', {
      validate: isUnique,
      getMessage: (field, params, data) => {
        return data.message
      }
    })
  },
  methods: {
    updateEmailData (event) {
      this.emailValue = event.target.value
      this.$emit('input', this.emailValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/inputs/email/email.js